import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import Echo from '../plugins/echo/echo';
import { BaseInfoActions } from '../Reducer/BaseInfoReducer';
import { showInAppNoti } from '../Reducer/InAppNotiReducer';
import {
  handlePermitNotification,
  handleWorkStopNotification,
  scheduleLocalNotification,
} from '../Components/Util/fcmHelpers';
import { BackInfoActions } from '../Reducer/BackInfoReducer';
import { useNavigate } from 'react-router-dom';

export const useFcmReceiver = (Search3) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { fcmReceptionPayload, userInfo } = useSelector((s) => s.BaseInfo);

  const handleRouting = (data) => {
    if (!data || !data.route) return;
    if (!userInfo || Object.keys(userInfo).length === 0) return;

    const { title, route, responseData } = data;
    let url = '/Home';

    if (title === '작업중지') {
      const isManager =
        userInfo.authCd === 'HEAD_MANAGER' ||
        userInfo.authCd === 'BUSINESS_OWNER';
      url = isManager
        ? `/M_WorkStop/detail/${responseData}`
        : `/M_WorkStop/${responseData}`;
    } else if (title === '작업허가서') {
      url = `${route}/detail/${responseData}`;
    } else {
      url = route;
    }

    dispatch(BackInfoActions.clear());
    dispatch(
      BackInfoActions.push({ id: 'root_home', type: 'page', path: '/Home' })
    );

    navigate(url, { replace: true });
    dispatch(BaseInfoActions.setFcmReceptionPayload({}));
  };

  useEffect(() => {
    if (!fcmReceptionPayload?.data || fcmReceptionPayload.isClicked) return;

    const { title, body, responseData, gubun } = fcmReceptionPayload.data;

    dispatch(
      showInAppNoti({
        gubun,
        responseData,
        body,
        onClick: () => handleRouting(fcmReceptionPayload.data),
      })
    );

    handlePermitNotification(dispatch, body);
    handleWorkStopNotification(dispatch, title, body, responseData, Search3);
  }, [fcmReceptionPayload, userInfo]);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const androidListener = Echo.addListener('fcmMessage', async (data) => {
      dispatch(
        BaseInfoActions.setFcmReceptionPayload({ data, isClicked: false })
      );
      await scheduleLocalNotification(data.title, data.body);
    });

    const iosListener = PushNotifications.addListener(
      'pushNotificationReceived',
      (notification) => {
        const data = notification.data;
        dispatch(
          BaseInfoActions.setFcmReceptionPayload({ data, isClicked: false })
        );
      }
    );

    const actionListener = PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification) => {
        const data = notification.notification?.data;
        if (data) {
          dispatch(
            BaseInfoActions.setFcmReceptionPayload({ data, isClicked: true })
          );
        }
      }
    );

    return () => {
      androidListener.remove();
      iosListener.remove();
      actionListener.remove();
    };
  }, []);

  useEffect(() => {
    if (fcmReceptionPayload?.isClicked) {
      handleRouting(fcmReceptionPayload.data);
    }
  }, [fcmReceptionPayload, userInfo]);
};
